import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { TenantComponentsEntity } from '../../domain/entities/tenant-components.entity';

/**
 * Tenant Components REST API service.
 * Handles HTTP communication with the super admin tenant provisioning endpoints.
 */
@Injectable()
export class TenantComponentsRestApi {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(AppConfigService);
  private readonly baseUrl = `${this.appConfig.versionedApiUrl}/admin/tenant-components`;

  public getComponents(): Observable<TenantComponentsEntity> {
    return this.http.get<TenantComponentsEntity>(this.baseUrl);
  }

  public updateComponents(components: {
    sharedServicesPortalEnabled: boolean;
    employeeRelationsPortalEnabled: boolean;
  }): Observable<void> {
    return this.http.put<void>(this.baseUrl, components);
  }
}
